const latestNews = document.querySelectorAll('.latest-news-module');

latestNews.forEach((news) => {
  const filters = news.querySelectorAll('.latest-news-module__filter');
  const items = news.querySelectorAll('[data-latest-news-item]');

  filters.forEach((btn) => {
    btn.addEventListener('click', () => {
      const { id } = btn;

      filters.forEach((active) => active.classList.remove('is-active'));
      btn.classList.add('is-active');

      items.forEach((section) => {
        section.classList.toggle('is-active', section.dataset.latestNewsItem === id);
      });
    });
  });
});

const latestNewsSlider = document.querySelectorAll('[data-slider="latest-news-slider"]');

if (latestNewsSlider.length > 0) {
  const latestNewsSliderOptions = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    speed: 800,
    watchOverflow: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      767: {
        spaceBetween: 24,
      },
      1023: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  };

  const initLatestNewsSlider = () => {
    latestNewsSlider.forEach((el) => {
      const parentEle = el.closest('[data-slider-parent]');
      const arrowRight = parentEle?.querySelector('.arrow-right');
      const arrowLeft = parentEle?.querySelector('.arrow-left');
      const options = {
        ...latestNewsSliderOptions,
        navigation: {
          nextEl: arrowRight,
          prevEl: arrowLeft,
        },
      };

      if (windowWidth() > 767) {
        new Swiper(el, options);
      } else {
        enableArrowScrollSync(parentEle);
      }
    });
  };

  initLatestNewsSlider();

  setupResponsiveSliders({
    sliderElements: latestNewsSlider,
    breakpoint: 767,
    initSlider: initLatestNewsSlider,
    mobileFallback: enableArrowScrollSync,
    parentSelector: '[data-slider-parent]',
  });
}
